// Display-only lifecycle overrides with two carve-outs for the partial-acceptance case.
//
// deriveMilestoneDisplayLifecycle — pill surface:
//   When partial acceptance is recorded but full acceptance is not, show
//   "partially-accepted" regardless of any payment timestamp.
//
// deriveTimelineDotLifecycle — timeline dot surface:
//   Same partial+paid condition, but returns "partial-paid" so the dot can
//   render the split emerald/amber gradient. The string is a display-only
//   extension; it is NOT part of MilestoneDerivedStatus.

import {
  deriveMilestoneLifecycleStatus,
  type MilestoneDerivedStatus,
  type MilestoneLifecycleTimestamps,
} from "./deriveMilestoneStatus";
import { isSet } from "./milestoneInput";

export function deriveMilestoneDisplayLifecycle(
  m: MilestoneLifecycleTimestamps,
): MilestoneDerivedStatus {
  const base = deriveMilestoneLifecycleStatus(m);
  if (base === "paid" && isSet(m.partiallyAcceptedAt) && !isSet(m.acceptedAt)) {
    return "partially-accepted";
  }
  return base;
}

/** Returns the lifecycle key to pass to `dotClass`. Returns `"partial-paid"` when
 *  a partial acceptance and payment are both recorded without full acceptance,
 *  allowing the timeline dot to render the split emerald/amber gradient. */
export function deriveTimelineDotLifecycle(
  m: MilestoneLifecycleTimestamps,
): MilestoneDerivedStatus | "partial-paid" {
  const base = deriveMilestoneLifecycleStatus(m);
  if (base === "paid" && isSet(m.partiallyAcceptedAt) && !isSet(m.acceptedAt)) {
    return "partial-paid";
  }
  return base;
}
